<template>
    <div id="detail-barang" class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <div v-else>
            <b-row>
                <b-col md="6">
                    <div id="delivery-batch" class="font-weight-bold">
                        Kloter Pengiriman
                    </div>
                    {{ $helper.parseDate(item.delivery_date) }} - Cabang
                    {{ item.branch }}
                </b-col>
                <b-col md="6">
                    <div id="item-status" class="font-weight-bold">
                        Status Barang
                    </div>
                    <b-badge :variant="parseStatusVariant(item.status)">
                        {{ parseStatusName(item.status) }}
                    </b-badge>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <div>
                        <div id="item-kind" class="font-weight-bold">
                            Jenis Barang
                        </div>
                        {{ item.kind }}
                    </div>
                    <div>
                        <div id="item-brand" class="font-weight-bold mt-3">
                            Merk Barang
                        </div>
                        {{ item.brand }}
                    </div>
                    <div v-if="itemFlags.isLMRetro">
                        <div class="font-weight-bold mt-3">
                            Merk Cap dari PGI
                        </div>
                        {{ item.pgi_gold_mint_mark || "-" }}
                    </div>
                    <div v-if="!itemFlags.isLMScan">
                        <div class="font-weight-bold mt-3">
                            Berat Kotor dari PGI
                        </div>
                        {{ item.pgi_dry_weight || "-" }}gr
                    </div>
                </b-col>
                <b-col md="6">
                    <div>
                        <div id="item-invoice" class="font-weight-bold">
                            No. Faktur PGI
                        </div>
                        {{ item.no_faktur }}
                    </div>
                    <div>
                        <div id="item-type" class="font-weight-bold mt-3">
                            Tipe Barang
                        </div>
                        {{ item.type }}
                    </div>
                    <div v-if="!itemFlags.isLMScan">
                        <div class="font-weight-bold mt-3">
                            {{ isPgiRule ? "Kadar XRF dari PGI" : "Kadar dari PGI" }}
                        </div>
                        {{ item.pgi_purity || "-" }}
                    </div>
                    <div v-if="!itemFlags.isLMScan">
                        <div class="font-weight-bold mt-3">
                            Berat Potongan dari PGI
                        </div>
                        {{ item.pgi_weight_reduction || "-" }}gr
                    </div>
                </b-col>
            </b-row>
            <div v-if="item.status == 1" class="mt-3">
                <b-button
                    id="btn-declare-lost"
                    variant="danger"
                    @click="$bvModal.show('m-request-lost')"
                >
                    <i class="fa fa-times mr-2" />Nyatakan Hilang
                </b-button>
                <b-button
                    v-if="['PGI', 'SGP'].includes(item.source)"
                    id="btn-create-findings"
                    variant="danger"
                    class="ml-2"
                    @click="$bvModal.show('m-request-edit-emas')"
                >
                    <i class="fa fa-question mr-2" />Buat Temuan
                </b-button>
            </div>
            <hr />
            <div v-if="item.status == 1">
                <div class="mb-3" v-if="!itemFlags.isLMScan">
                    <b-row>
                        <b-col md="6">
                            <div>
                                <b-form-group
                                    :label="isPgiRule ? 'Kadar XRF' : 'Kadar'"
                                    class="font-weight-bold"
                                >
                                    <b-form-input
                                        v-if="isPgiRule"
                                        v-model="input.purityXrf"
                                        placeholder="Masukkan kadar XRF"
                                        :tabindex="1"
                                    />
                                    <b-form-input
                                        v-else
                                        v-model="input.purity"
                                        placeholder="Masukkan kadar"
                                        :tabindex="1"
                                    />
                                </b-form-group>
                            </div>
                            <div :style="isPgiRule ? null : 'margin-top: 38px;'">
                                <b-form-group
                                    label="Berat Kotor"
                                    class="font-weight-bold"
                                    :description="isPgiRule ? null : 'Opsional. Jika tidak diisi, akan menggunakan berat kotor PGI.'"
                                >
                                    <b-input-group append="gr">
                                        <b-form-input
                                            v-model="input.dryWeight"
                                            placeholder="Masukkan berat kotor"
                                            :state="dryWeightState"
                                            :tabindex="2"
                                        />
                                    </b-input-group>
                                    <b-form-invalid-feedback :state="dryWeightState">
                                        Selisih berat kering melewati batas toleransi (±{{ item.attr && item.attr.dry_weight_tolerance }} gr). Silakan Buat Temuan.
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div v-if="itemFlags.isPerhiasan">
                                <b-form-group
                                    label="Merk Cap Emas"
                                    class="font-weight-bold"
                                >
                                    <multiselect
                                        class="font-weight-normal"
                                        v-model="input.goldMintMark"
                                        :allow-empty="false"
                                        label="name"
                                        track-by="id"
                                        :internal-search="true"
                                        placeholder="-- Pilih Salah Satu --"
                                        :options="optGoldMintMarks"
                                        :tabindex="5"
                                    />
                                </b-form-group>
                            </div>
                            <div v-if="!itemFlags.isLMRetro">
                                <b-form-group
                                    label="Jumlah Keping"
                                    class="font-weight-bold"
                                >
                                    <b-input-group append="pcs">
                                        <b-form-input
                                            v-model="input.pieceCount"
                                            placeholder="Masukkan jumlah keping"
                                            :tabindex="7"
                                        />
                                    </b-input-group>
                                </b-form-group>
                            </div>
                        </b-col>
                        <b-col md="6">
                            <div v-if="isPgiRule">
                                <b-form-group
                                    label="Kadar Jual"
                                    class="font-weight-bold"
                                >
                                    <b-form-input
                                        v-model="input.purity"
                                        placeholder="Masukkan kadar jual"
                                        :state="puritySellState"
                                        :tabindex="1"
                                    />
                                    <b-form-invalid-feedback :state="puritySellState">
                                        Kadar Jual tidak boleh lebih rendah dari Kadar XRF.
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div>
                                <b-form-group
                                    label="Berat Potongan"
                                    class="font-weight-bold"
                                    :description="isPgiRule ? null : 'Opsional. Jika tidak diisi, akan menggunakan berat potongan PGI.'"
                                >
                                    <b-input-group append="gr">
                                        <b-form-input
                                            v-model="input.weightReduction"
                                            placeholder="Masukkan berat potongan"
                                            :state="weightReductionState"
                                            :tabindex="3"
                                        />
                                    </b-input-group>
                                    <b-form-invalid-feedback :state="weightReductionState">
                                        Berat potongan harus sama dengan data PGI. Silakan Buat Temuan.
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div v-if="itemFlags.isPerhiasan">
                                <b-form-group
                                    label="Ada Cap"
                                    class="font-weight-bold"
                                >
                                    <multiselect
                                        class="font-weight-normal"
                                        v-model="input.hasMark"
                                        label="name"
                                        :options="optBoolean"
                                        placeholder="-- Pilih Salah Satu --"
                                        :tabindex="4"
                                    />
                                </b-form-group>
                            </div>
                            <div
                                :style="isPgiRule ? null : 'margin-top: 38px;'"
                                v-if="itemFlags.isPerhiasan"
                            >
                                <b-form-group
                                    label="Tipe Emas"
                                    class="font-weight-bold"
                                >
                                    <multiselect
                                        class="font-weight-normal"
                                        v-model="input.goldType"
                                        :allow-empty="false"
                                        label="name"
                                        track-by="id"
                                        :internal-search="true"
                                        placeholder="-- Pilih Salah Satu --"
                                        :options="optGoldTypes"
                                        :tabindex="6"
                                    />
                                </b-form-group>
                            </div>
                            <div v-if="itemFlags.isPerhiasan">
                                <b-form-group
                                    label="Cap Getok"
                                    class="font-weight-bold"
                                >
                                    <multiselect
                                        class="font-weight-normal"
                                        v-model="input.isStamped"
                                        label="name"
                                        :options="optBoolean"
                                        placeholder="-- Pilih Salah Satu --"
                                        :tabindex="4"
                                    />
                                </b-form-group>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <b-row class="mb-3" v-if="itemFlags.isLMScan">
                    <b-col md="6">
                        <b-form-group label="Tahun" class="font-weight-bold">
                            <b-form-select
                                v-model="input.year"
                                :options="yearOptions"
                            >
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilih Tahun --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button
                            id="btn-approve-item"
                            variant="success"
                            :disabled="isSubmitting || hasInvalidState"
                            @click="promptSubmit"
                        >
                            {{
                                isSubmitting ? "Menyimpan..." : "Approve Barang"
                            }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
            <div v-else-if="item.status == 5">
                <!-- HILANG -->
                <div>
                    Dinyatakan hilang oleh
                    <span class="font-weight-bold">{{ item.approved_by }}</span>
                    pada {{ $helper.parseDate(item.approved_at) }},
                    {{ $helper.parseHourMinute(item.approved_at) }} WIB
                </div>
            </div>
            <div v-else>
                <!-- APPROVED, LAINNYA -->
                <h5 class="mb-0">Input Data Barang</h5>
                <div class="text-muted">
                    Approval dilakukan oleh
                    <span class="font-weight-bold">{{ item.approved_by }}</span>
                    pada {{ $helper.parseDate(item.approved_at) }},
                    {{ $helper.parseHourMinute(item.approved_at) }} WIB
                </div>
                <b-row class="mt-3">
                    <b-col md="6">
                        <div class="font-weight-bold">Grade</div>
                        {{ item.grade }}
                        <div class="font-weight-bold mt-3">Kelengkapan</div>
                        {{ item.is_batangan == true ? "Batangan" : "Lengkap" }}
                        <div class="font-weight-bold mt-3">Spek</div>
                        {{ item.spec }}
                        <div class="font-weight-bold mt-3">
                            Lokasi Penyimpanan
                        </div>
                        {{ item.warehouse || "-" }}
                    </b-col>
                    <b-col md="6">
                        <div class="font-weight-bold">
                            Aksesoris yang Tidak Ada
                        </div>
                        {{ item.missing_accessories || "-" }}
                        <div class="font-weight-bold mt-3">
                            Aksesoris yang Tidak Ori
                        </div>
                        {{ item.not_ori_accessories || "-" }}
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-modal
            id="m-request-lost"
            title="Nyatakan Barang Hilang"
            centered
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <b-form-group id="form-lost-note" label="Keterangan Hilang">
                <b-input
                    id="form-lost-note-input"
                    v-model="noteLost"
                    maxlength="200"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    id="btn-declare-lost-confirm"
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="promptItemLost"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Nyatakan Hilang" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="m-barcode"
            title="Cetak Barcode"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
        >
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak
            dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe
                id="barcode-frame"
                :src="getBarcodeLink()"
                height="300px"
                width="100%"
            />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodeType == 'barcode' ? 'Mini' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button id="btn-finish-approval" variant="primary" @click="finishApproval">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <ModalRequestEditEmas
            :item="item"
            receipt
            @refresh-items="$emit('variance-created')"
        />
    </div>
</template>

<script>
import ModalRequestEditEmas from "../inventory-emas/ModalRequestEditEmas.vue";
export default {
    name: "barang-masuk-detail-barang",
    components: {
        ModalRequestEditEmas
    },
    props: {
        inventoryId: { type: Number, required: true }
    },
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,

            item: {},
            input: {
                purity: null,
                purityXrf: null,
                dryWeight: null,
                weightReduction: null,
                goldMintMark: null,
                goldType: null,
                pieceCount: null,
                hasMark: null,
                isStamped: null,
                year: null
            },

            noteLost: "",

            optGoldMintMarks: [],
            optGoldTypes: [],
            optBoolean: [
                { value: true, name: "Ada" },
                { value: false, name: "Tidak Ada" }
            ],
            barcodeLink: "",
            barcodeLinkMini: "",
            barcodeType: 'barcode',
            barcodeToggleCooldown: false,

        }
    },
    methods: {
        init() {
            this.initStatus = 0;

            this.$axios
                .get("delivery/inventory/" + this.inventoryId)
                .then(res => {
                    this.item = res.data.data;

                    this.input.isBatangan = this.item.is_batangan_pgi == true;

                    this.input.color = this.item.item_color_id;

                    let fetchGoldMintMark = this.fetchGoldMintMark();

                    let fetchGoldType = this.fetchGoldType();

                    Promise.all([fetchGoldMintMark, fetchGoldType])
                        .then(() => {
                            this.initStatus = 1;
                        })
                        .catch(error => {
                            this.$helper.parseError(this, error);
                            this.initStatus = -1;
                        });
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.initStatus = -1;
                });
        },

        promptItemLost() {
            if (this.noteLost == "") {
                return this.$helper.toastError(
                    this,
                    "Mohon mengisi keterangan!"
                );
            }

            let isConfirmed = confirm("Nyatakan barang ini hilang?");
            if (!isConfirmed) return;

            this.isSubmitting = true;
            let payload = {
                id: this.inventoryId,
                note: this.noteLost
            };

            this.$axios
                .post("delivery/lost", payload)
                .then(() => {
                    this.$emit("lost");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        getBarcodeLink() {
            if (this.barcodeType == 'mini') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkMini}`
            }
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeType == 'barcode') this.barcodeType = 'mini'
            else this.barcodeType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        promptSubmit() {
            const purityLabel = this.isPgiRule ? "Kadar Jual" : "Kadar";
            const modes = {
                LMScan: [], // no need validation for LMScan
                LMRetro: [{ key: "purity", msg: `${purityLabel} tidak boleh kosong` }],
                Perhiasan: [
                    { key: "purity", msg: `${purityLabel} tidak boleh kosong` },
                    { key: "hasMark", msg: "Status Cap Tanda harus dipilih" },
                    {
                        key: "goldMintMark",
                        msg: "Merk Cap Emas tidak boleh kosong"
                    },
                    { key: "goldType", msg: "Tipe Emas tidak boleh kosong" },
                    {
                        key: "pieceCount",
                        msg: "Jumlah Keping tidak boleh kosong"
                    },
                    { key: "isStamped", msg: "Cap Getok harus dipilih" }
                ]
            };

            const isValidValue = val => val !== null && val !== "";

            if (this.isPgiRule) {
                const purityXrf = this.input.purityXrf;
                const min = this.itemFlags.isLMRetro ? 850 : 1;
                if (!isValidValue(purityXrf) || purityXrf < min || purityXrf > 1000) {
                    this.$helper.toastError(this, `Kadar XRF wajib diisi, antara ${min} dan 1000`);
                    return;
                }
            }

            let ruleSet = null;
            if (this.itemFlags.isLMScan) ruleSet = modes.LMScan;
            else if (this.itemFlags.isLMRetro) ruleSet = modes.LMRetro;
            else if (this.itemFlags.isPerhiasan) ruleSet = modes.Perhiasan;

            if (ruleSet) {
                for (const { key, msg } of ruleSet) {
                    const val = this.input[key];
                    if (!isValidValue(val)) {
                        this.$helper.toastError(this, msg);
                        return;
                    }
                }
            } else {
                this.$helper.toastError(this, "Tipe Barang tidak valid");
                return;
            }

            if (
                isValidValue(this.input.purity) &&
                (this.input.purity < 1 || this.input.purity > 1000)
            ) {
                this.$helper.toastError(
                    this,
                    `${purityLabel} harus berada di antara 1 dan 1000`
                );
                return;
            }

            if (
                this.itemFlags.isLMRetro &&
                isValidValue(this.input.purity) &&
                (this.input.purity < 850 || this.input.purity > 1000)
            ) {
                this.$helper.toastError(
                    this,
                    `${purityLabel} untuk LM Retro harus berada di antara 850 dan 1000`
                );
                return;
            }

            // PGI/SGP: weights are mandatory, no fallback to PGI data
            const finalDryWeight = isValidValue(this.input.dryWeight) || this.isPgiRule
                ? this.input.dryWeight
                : this.item.pgi_dry_weight;

            if (!finalDryWeight && !this.itemFlags.isLMScan) {
                this.$helper.toastError(this, "Berat kotor tidak boleh kosong");
                return;
            }

            const finalWeightReduction = isValidValue(
                this.input.weightReduction
            ) || this.isPgiRule
                ? this.input.weightReduction
                : this.item.pgi_weight_reduction;

            if (!finalWeightReduction && !this.itemFlags.isLMScan) {
                this.$helper.toastError(
                    this,
                    "Berat potongan tidak boleh kosong"
                );
                return;
            }

            let confirmable = true;

            if (confirmable) {
                let confirmed = confirm(
                    "Lakukan approval dengan data input ini?"
                );
                if (confirmed) {
                    const payload = {
                        id: this.inventoryId,
                        purity: this.input.purity,
                        dry_weight: finalDryWeight,
                        weight_reduction: finalWeightReduction,
                        gold_mint_mark_id:
                            this.input.goldMintMark != null
                                ? this.input.goldMintMark.id
                                : null,
                        gold_type_id:
                            this.input.goldType != null
                                ? this.input.goldType.id
                                : null,
                        piece_count: this.input.pieceCount,
                        has_mark: this.input.hasMark
                            ? this.input.hasMark.value
                            : null,
                        is_stamped: this.input.isStamped
                            ? this.input.isStamped.value
                            : null,
                        year: this.input.year || null
                    };
                    if (this.isPgiRule) payload.purity_xrf = this.input.purityXrf;

                    this.isSubmitting = true;
                    this.$axios.post("delivery/approve-gold", payload).then(res => {
                        this.barcodeLink = res.data.data.link;
                        this.barcodeLinkMini = res.data.data.link_mini;
                        this.$bvModal.show('m-barcode');
                    })
                        .catch(error => this.$helper.parseError(this, error))
                        .finally(() => (this.isSubmitting = false));
                }
            }
        },

        finishApproval() {
            this.$bvModal.hide("m-barcode");
            this.$emit("approved");
        },

        parseStatusVariant(status) {
            switch (status) {
                case 1:
                    return "warning";
                case 2:
                    return "success";
                case 5:
                    return "danger";
                default:
                    return "light";
            }
        },

        parseStatusName(status) {
            switch (status) {
                case 1:
                    return "PENDING";
                case 2:
                    return "APPROVED";
                case 5:
                    return "HILANG";
                default:
                    return "LAINNYA";
            }
        },

        sanitize(item) {
            let cleaned = String(item.adjustment).replace(/\./g, "");
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            item.adjustment = res;
        },

        async fetchGoldMintMark() {
            await this.$axios.get("master/gold-mint-mark").then(res => {
                this.optGoldMintMarks = res.data.data;
            });
        },

        async fetchGoldType() {
            await this.$axios.get("master/gold-type").then(res => {
                this.optGoldTypes = res.data.data;
            });
        }
    },
    computed: {
        yearOptions() {
            const current = new Date().getFullYear();
            const years = [];
            for (let y = current; y >= 2000; y--) {
                years.push(String(y));
            }
            return years;
        },
        itemFlags() {
            return {
                isLMRetro: this.item.kind_id === 261,
                isLMScan: this.item.kind_id === 251,
                isPerhiasan: this.item.kind_id === 257
            };
        },
        isPgiRule() {
            return ["PGI", "SGP"].includes(this.item.source) && !this.itemFlags.isLMScan;
        },
        // Mirrors BE GoldHelper::buildParameter: compare in 1/10000 units to avoid float drift.
        dryWeightState() {
            if (!this.isPgiRule || !this.item.attr) return null;
            const input = parseFloat(this.input.dryWeight);
            const pgi = parseFloat(this.item.pgi_dry_weight);
            const tolerance = parseFloat(this.item.attr.dry_weight_tolerance);
            if (isNaN(input) || isNaN(pgi) || isNaN(tolerance)) return null;
            return Math.round(pgi * 10000) - Math.round(input * 10000) <= Math.round(tolerance * 10000);
        },
        weightReductionState() {
            if (!this.isPgiRule) return null;
            const input = parseFloat(this.input.weightReduction);
            const pgi = parseFloat(this.item.pgi_weight_reduction);
            if (isNaN(input) || isNaN(pgi)) return null;
            return Math.round(input * 10000) === Math.round(pgi * 10000);
        },
        puritySellState() {
            if (!this.isPgiRule || !this.input.purity || !this.input.purityXrf) return null;
            return Number(this.input.purity) >= Number(this.input.purityXrf);
        },
        hasInvalidState() {
            return [this.dryWeightState, this.weightReductionState, this.puritySellState].includes(false);
        }
    },

    created() {
        this.init();
    }
};
</script>

<style scoped></style>
